import { ReceiptsViewInitEpic } from './ReceiptsViewInitEpic';
import { ReceiptsViewOnFetchReceiptsEpic } from './ReceiptsViewOnFetchReceiptsEpic';
import { ReceiptsViewOnRouteEpic } from './ReceiptsViewOnRouteEpic';

export const rootReceiptsViewEpics = [
  ReceiptsViewInitEpic,
  ReceiptsViewOnRouteEpic,
  ReceiptsViewOnFetchReceiptsEpic,
];
